export const NAME = 'user'
export const SET_FIELD = 'SET_USER_FIELD'
export const SET_LOCKED = 'SET_USER_LOCKED'
export const SET_HIDDEN = 'SET_USER_HIDDEN'
export const SET_SAVED = 'SET_USER_SAVED'
export const SET_LOADED = 'SET_USER_LOADED'
export const CLEAR = 'CLEAR_USER'
export const SET_FORM = 'SET_USER_FORM'
export const SET_LOCATION = 'SET_USER_LOCATION'